import { ReactElement, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ButtonIcon } from 'components/general';
import { StateToggleIcon } from 'components/common/StateToggleIcon';
import { formatTranslation } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';
import { Color } from 'shared/utils/colors';
import {
  EntityState,
  getNextEntityState,
  isEntityStatePublished,
} from 'components/common/dataGrid/columnsFactory/types';
import { useInspectionStore } from 'store/inspection';

const toggleOnIconSx = { color: Color.black };
const toggleOffIconSx = { color: Color.iconGray };

const INSPECTION_STATE_TOOLTIP_KEYS = {
  [EntityState.published]: InspectionTranslationKeys.stateActiveTooltip,
  [EntityState.archived]: InspectionTranslationKeys.stateArchivedTooltip,
} as const;

export function InspectionStateToggle(): ReactElement {
  const intl = useIntl();

  const state = useInspectionStore.use.inspectionListState();
  const setState = useInspectionStore.use.setInspectionListState();

  const isPublished = isEntityStatePublished(state);

  const handleClick = useCallback(() => {
    setState(getNextEntityState(state));
  }, [state, setState]);

  return (
    <ButtonIcon
      onClick={handleClick}
      title={formatTranslation(intl, INSPECTION_STATE_TOOLTIP_KEYS[state])}
    >
      <StateToggleIcon
        isOn={isPublished}
        onIconSx={toggleOnIconSx}
        offIconSx={toggleOffIconSx}
      />
    </ButtonIcon>
  );
}
